module.exports = __webpack_public_path__ + "static/media/ico_deman_o.270bb8a5.svg";